export const apiClientLoaded = (loaded) => {
    return {
        type: 'CLIENT_LOADED',
        loaded
    }
}


// WEBPACK FOOTER //
// ./src/common/ApiClient/ApiClientActions.jsx